import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, FileText, Boxes, Microscope, Lock, Headphones } from "lucide-react";

const ITEMS = [
  { icon: FileText, title: "Product Documentation", desc: "Specification sheets and reference detail provided with applicable listings." },
  { icon: Boxes, title: "Batch Information", desc: "Batch references included where available for full traceability." },
  { icon: Microscope, title: "Transparent Sourcing", desc: "Clear, honest information about what each product is and how it is prepared." },
  { icon: ShieldCheck, title: "Clear Specifications", desc: "Every listing states format, grade and storage so you know exactly what you receive." },
  { icon: Lock, title: "Secure Checkout", desc: "A straightforward, privacy-respecting ordering process from start to finish." },
  { icon: Headphones, title: "Professional Support", desc: "A responsive UK support team ready to help with any research enquiry." },
];

export const Transparency = () => (
  <section id="transparency" className="relative py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">Our Standards</span>
        <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Built Around <span className="metallic-text">Transparency.</span>
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-slate-600">
          Trust is earned through clarity. We present honest, verifiable information about every resource we offer — no inflated claims, just precise detail.
        </p>
      </motion.div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.title}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className="group rounded-2xl glass metallic-border p-6 card-hover"
          >
            <span className="grid h-11 w-11 place-items-center rounded-xl border border-slate-200 bg-white text-slate-800 transition-colors group-hover:border-slate-400">
              <it.icon className="h-5 w-5" />
            </span>
            <h3 className="mt-4 font-display text-lg font-semibold text-slate-900">{it.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{it.desc}</p>
          </motion.div>
        ))}
      </div>

      <p className="mt-10 max-w-3xl text-sm leading-relaxed text-slate-500">
        We only state what we can stand behind. Where documentation, batch data or specifications are supplied by the business, they are shown on the relevant product. Unsupported superlatives are deliberately avoided.
      </p>
    </div>
  </section>
);

export default Transparency;
